import request from "@/router/axios"
export const list = (query) => {
    return request({
        url: `/api/sys/menuInfo/list`,
        method: 'post',
        data: query
    })
}
export const page = (query) => {
    return request({
        url: `/api/sys/menuInfo/page`,
        method: 'post',
        data: query
    })
}
export const detail = (params) => {
    return request({
        url: `/api/sys/menuInfo/detail`,
        method: 'get',
        params: {
            ...params
        }
    })
}
export const add = (data) => {
    return request({
        url: `/api/sys/menuInfo/add`,
        method: 'post',
        data: data
    })
}
export const edit = (data) => {
    return request({
        url: `/api/sys/menuInfo/edit`,
        method: 'post',
        data: data
    })
}
export const remove = (ids) => {
    return request({
        url: `/api/sys/menuInfo/del`,
        method: 'post',
        params: {
            ids
        }
    })
}